//onboarder
export const SET_ONBOARDER = "SET_ONBOARDER";
export const SET_PROFILE = "SET_PROFILE";
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const CLEAR_ONBOARDER = "CLEAR_ONBOARDER";
//user
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const USER_DATA_SUCCESS = "USER_DATA_SUCCESS";
export const REPORT_DATA_SUCCESS = "REPORT_DATA_SUCCESS";
export const FORGOT_PASSWORD = "FORGOT_PASSWORD";
export const PASSWORD_RESET_SUCCESS = "PASSWORD_RESET_SUCCESS";
export const SET_P_TOKEN = "SET_P_TOKEN";
export const CLEAR_MY_DATA = "CLEAR_MY_DATA";
//other
export const SET_CONTENT_KEY = "SET_CONTENT_KEY";
export const SET_CONTENT_KEY_G = "SET_CONTENT_KEY_G";
export const SET_MAIN_KEY = "SET_MAIN_KEY";
export const SET_SIDE_TAB_KEY = "SET_SIDE_TAB_KEY";
export const SET_SIDE_TAB_KEY_G = "SET_SIDE_TAB_KEY_G";
export const SET_UNDERLINE_KEY = "SET_UNDERLINE_KEY";
export const GOOGLE_SIGN_UP = "GOOGLE_SIGN_UP";
export const GOOGLE_SIGN_IN = "GOOGLE_SIGN_IN";
export const FACEBOOK_SIGN_UP = "FACEBOOK_SIGN_UP";